import { ModuleLayout } from 'components/layout/ModuleLayout';
import { ApiOutputContainer } from 'components/resources/apiOutput/apiOutputContainer';

export function ApiOutput() {
  return (
    <ModuleLayout className='bg-gray-100'>
      <ApiOutputContainer />
    </ModuleLayout>
  );
}
